<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card no-body>
          <b-tabs v-model="activeTabIndex" card lazy>
            <div class="mx-3">
              <div class="patient-info-card p-3 mb-3 border rounded">
                <h4 class="mb-3 text-primary">
                  {{ $t("common.patient_information") }}
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <div class="d-flex mb-2 align-items-center">
                      <span class="font-weight-bold mr-2"
                        >{{ $t("common.name") }}:</span
                      >
                      <span class="text-primary">{{
                        getNestedProperty(patientInfo, "name")
                      }}</span>
                    </div>
                    <div class="d-flex mb-2 align-items-center">
                      <span class="font-weight-bold mr-2"
                        >{{ $t("reception.gender") }}:</span
                      >
                      <span class="text-primary">{{
                        getNestedProperty(patientInfo, "gender")
                      }}</span>
                    </div>
                    <div class="d-flex mb-2 align-items-center">
                      <span class="font-weight-bold mr-2"
                        >{{ $t("reception.birth-date") }}:</span
                      >
                      <span class="text-primary">{{
                        getNestedProperty(patientInfo, "birth_date")
                      }}</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex mb-2 align-items-center">
                      <span class="font-weight-bold mr-2"
                        >{{ $t("reception.occupation") }}:</span
                      >
                      <span class="text-primary">{{
                        getNestedProperty(patientInfo, "occupation")
                      }}</span>
                    </div>
                    <div class="d-flex mb-2 align-items-center">
                      <span class="font-weight-bold mr-2"
                        >{{ $t("reception.phone") }}:</span
                      >
                      <span
                        class="text-primary"
                        :style="{
                          direction: $store.state.appConfig.isRTL
                            ? 'rtl'
                            : 'ltr',
                        }"
                      >
                        {{ getNestedProperty(patientInfo, "phone") }}
                      </span>
                    </div>
                    <div class="d-flex mb-2 align-items-center">
                      <span class="font-weight-bold mr-2"
                        >{{ $t("common.room") }}:</span
                      >
                      <span class="text-primary">{{ getLastRoomName() }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-tab :title="$t('surgery.set-surgery-price')">
              <b-card-text>
                <setSurgeryPrice active />
              </b-card-text>
            </b-tab>
            <b-tab :title="$t('hospital.outclinic-invoices')">
              <b-card-text>
                <div class="d-flex justify-content-end">
                  <b-button
                    v-if="$route.query.patientCardId"
                    @click="
                      $router.push({
                        name: 'out-clinic-invoices',
                        params: {
                          id: $route.query.patientCardId,
                          name: patientInfo.name,
                        },
                      })
                    "
                  >
                    {{ $t("reception.out-clinic-invoices") }}
                  </b-button>
                </div>

                <OutClinicInvoices
                  :patientData="patientInfo"
                  @onChangeStatus="getInvoicesAfterChange()"
                  :invoices="invoicesOut"
              /></b-card-text>
            </b-tab>

            <b-tab :title="$t('hospital.surgery-deposit-invoices')">
              <b-card-text>
                <div class="d-flex justify-content-end">
                  <b-button
                    v-if="$route.query.patientCardId"
                    @click="
                      $router.push({
                        name: 'invoice-insurance-surgery',
                        params: {
                          id: $route.query.patientCardId,
                          name: patientInfo.name,
                        },
                      })
                    "
                  >
                    {{ $t("hospital.add-surgery-invoice-deposit-invoices") }}
                  </b-button>
                </div>
                <SurgeryDepositInvoices
                  @onChangeStatus="getInvoicesAfterChange()"
                  :invoices="invoice_insurance_surgery"
              /></b-card-text>
            </b-tab>
            <b-tab :title="$t('hospital.patient-surgery-invoices')">
              <b-card-text
                ><allSurgeresInvoices
                  @onChangeStatus="getPatientSurgeriesInvoices()"
                  :getData="getPatientSurgeriesInvoices"
                  :patientData="patientInfo"
                  :patientSurgeryId="
                    this.patientHasSurgery && patientInfo.surgeries[0].id
                  "
                  :patient_card_surgery_id="patient_card_surgery_id"
                  :invoices="patientInfo.invoice_patient_surgery"
                  @reloadInvoices="getPatientInvoices()"
              /></b-card-text>
            </b-tab>
            <b-tab :title="$t('common.patient-stay-invoice')">
              <b-card-text>
                <PatientStayInvoice />
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BLink,
  BDropdown,
  BSpinner,
  BDropdownItem,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BModal,
  BCardText,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardBody,
  BPagination,
  BTable,
  BTab,
  BTabs,
} from "bootstrap-vue";
import vSelect from "vue-select";
const PatientCard = () => import("@/views/Reception/PatientCard.vue");
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
const OutClinicInvoices = () =>
  import("@/components/invoices/OutClinicInvoices.vue");
const SurgeryDepositInvoices = () => import("./SurgeryDepositInvoices.vue");
const allSurgeresInvoices = () => import("./allSurgeresInvoices.vue");
const OutClinicInvoice = () =>
  import("@/components/printables/OutClinicInvoice.vue");
const setSurgeryPrice = () => import("./SurgeryPatientHistoryAccounting.vue");
const PatientStayInvoice = () => import("./PatientStayInvoice.vue");
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import router from "@/router";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BLink,
    BDropdown,
    BDropdownItem,
    BTooltip,
    BTab,
    BTabs,
    vSelect,
    ToastificationContent,
    VuePhoneNumberInput,
    DeleteModal,
    ActionsButtons,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BCardText,
    BFormCheckbox,
    BFormCheckboxGroup,
    BCardBody,
    BPagination,
    BTable,
    PatientCard,
    OutClinicInvoices,
    SurgeryDepositInvoices,
    allSurgeresInvoices,
    setSurgeryPrice,
    PatientStayInvoice,
  },
  data() {
    return {
      patientData: [],
      take: 20,
      invoices: {
        invoice_out_clinic: [],
        invoice_insurance_surgery: [],
        invoice_patinet_surgery: [],
      },
      invoicesOut: { data: [] },
      invoice_insurance_surgery: { data: [] },
      currentPatienTCardId: "",
      patientInfo: {},
      patientHasSurgery: false,
      itemClickedList: [],
      tableColumns: [
        {
          key: "amount",
          label: this.$t("employee.amount"),
          sortable: true,
        },

        {
          key: "created_at",
          sortable: true,
          label: this.$t("common.created-at"),
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      dataCount: 0,
      filters: {
        fromDate: null,
        toDate: null,
      },
      patient_card_surgery_id: null,
      patientRoom: null,
      activeTabIndex: 0,
      isInitializing: true,
    };
  },
  mounted() {
    // Comment #1: Restore the last active tab from localStorage
    const savedTabIndex = localStorage.getItem("invoices-active-tab");
    console.log('Saved tab index from localStorage:', savedTabIndex);
    
    if (savedTabIndex !== null) {
      const tabIndex = parseInt(savedTabIndex, 10);
      console.log('Parsed tab index:', tabIndex);
      
      // Comment #14: Use nextTick to ensure DOM is ready before setting tab
      this.$nextTick(() => {
        this.activeTabIndex = tabIndex;
        console.log('Set activeTabIndex to:', this.activeTabIndex);
        
        // Comment #15: Load content for the restored tab
        this.loadTabContent(tabIndex);
        
        // Comment #16: Mark initialization as complete after a short delay
        setTimeout(() => {
          this.isInitializing = false;
          console.log('Initialization complete');
        }, 100);
      });
    } else {
      // Comment #17: No saved tab, use default and mark initialization complete
      this.$nextTick(() => {
        this.loadTabContent(0);
        this.isInitializing = false;
      });
    }

    this.getPatientInvoices();
    this.getPatientCard();
    // console.log("isPatientAccounting", this.$route.params.isPatientAccounting);
    // console.log("isSurgeryAccounting", this.$route.params.isSurgeryAccounting);
  },
  methods: {
    getNestedProperty(obj, path, defaultValue = "") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
      return result;
    },
    async getPatientCard() {
      await this.getList(
        `/patientCard/${this.$route.params.patientCardId}?include[]=patientRoom`
      );

      this.patientRoom = this.getNestedProperty(this.all_data, "patient_room");
      console.log("patientRoom", this.patientRoom);
    },
    getLastRoomName() {
      if (!this.patientRoom || this.patientRoom.length === 0) return "-";
      const lastRoom = this.patientRoom[this.patientRoom.length - 1];
      return this.getNestedProperty(lastRoom, "room.name") || "-";
    },
    reloadInvoices(data) {
      this.filters.fromDate = data.fromDate;
      this.filters.toDate = data.toDate;
      this.getPatientInvoices();
    },
    getInvoicesAfterChange() {
      setTimeout(() => {
        window.location.reload();
      }, 200);
    },
    async getPatientInvoices() {
      this.loading = true;
      await this.getPatient(
        `/patient/invoices?filter[id]=${this.$route.params.patientId}&include=patientCards&sort=-id`
      );
      this.loading = false;
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.patientData = this.all_data.data;
      this.patientInfo = this.all_data.data[0];
      this.patient_card_surgery_id = this.all_data.data;
      //console.log("patient_card_surgery_id", this.patient_card_surgery_id);
      this.invoicesOut.data = this.patientInfo.invoice_out_clinic;
      this.invoice_insurance_surgery.data =
        this.patientInfo.invoice_insurance_surgery;
      this.invoice_patient_surgery = this.patientInfo.invoice_patient_surgery;
      //console.log("patientData", this.invoice_patient_surgery);
    },

    // Comment #7: Separate method to load tab content
    async loadTabContent(tabIndex) {
      console.log('Loading content for tab:', tabIndex);
      switch (tabIndex) {
        case 0:
          // Comment #9: Tab 0 - Surgery Price Setting (no specific loading needed)
          console.log('Loading tab 0 - Surgery Price Setting');
          break;
        case 1:
          console.log('Loading tab 1 - OutClinic Invoices');
          this.getInvoices("invoice_out_clinic");
          break;
        case 2:
          console.log('Loading tab 2 - Surgery Deposit Invoices');
          this.getInvoices("invoice_insurance_surgery");
          break;
        case 3:
          console.log('Loading tab 3 - Patient Surgery Invoices');
          this.getPatientSurgeriesInvoices();
          await this.getPatientInvoices();
          break;
        case 4:
          // Comment #10: Tab 4 - Patient Stay Invoice (no specific loading needed)
          console.log('Loading tab 4 - Patient Stay Invoice');
          break;
        default:
          // Comment #4: Default to first tab if invalid index
          console.log('Invalid tab index, using default');
          break;
      }
    },
    async getInvoices(type) {
      let url = `/invoices?filter[patient_card_id]=${this.$route.query.patientCardId}&filter[type]=${type}&page=${this.page}&take=${this.take}&sort=-id&include=service,surgery,patientCard,doctor`;
      //console.log("get invoice");
      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.invoices = this.all_data;
      this.loading = false;
      this.invoice_insurance_surgery = this.all_data;
    },
    async getPatientSurgeriesInvoices() {
      if (this.patientHasSurgery) {
        let url = `/invoicePatientSergury?filter[patient_card_surgery_id]=${this.patientInfo.surgeries[0].id}&page=${this.page}&take=${this.take}&sort=-id`;

        await this.getList(url);
        this.dataCount = this.all_data.total;
        this.invoices = this.all_data;
        //console.log("invoices", this.invoices);
        this.loading = false;
      } else {
        return;
      }
    },
    itemClicked(id) {
      this.currentPatienTCardId = id;
    },
  },
  watch: {
    // Comment #18: Watch for tab changes after initialization
    activeTabIndex(newIndex, oldIndex) {
      console.log('Watcher triggered, tab changed from:', oldIndex, 'to:', newIndex, 'isInitializing:', this.isInitializing);
      if (!this.isInitializing && newIndex !== null && newIndex !== undefined) {
        localStorage.setItem("invoices-active-tab", newIndex.toString());
        this.loadTabContent(newIndex);
      }
    }
  },
};
</script>
<style scoped>
.font-modify {
  letter-spacing: normal !important;
}

.pdf-content {
  margin: 2rem;
}

.modify_result_display {
  width: 25rem;
  margin: auto;
  color: rgb(255, 255, 255);
}

.modify_result_display_div {
  border-radius: 8px;
  margin: -22px;
  padding: 10px;
  margin-top: 10px;
  background: rgb(25, 0, 255);
}

.Risk_bg {
  margin: 1.5rem 0.5rem;
  border-radius: 8px;
  border-top: 3px solid rgb(25, 0, 255);
  border-left: 3px solid rgb(25, 0, 255);
  border-right: 3px solid rgb(25, 0, 255);
}

.timeline {
  max-width: 300px;
  color: #fdfdfd;
  padding: 30px 10px;
}

.timeline ul {
  list-style-type: none;
  border-left: 2px solid #094a68;
  padding: 10px 5px;
}

.timeline ul li {
  padding: 20px 10px;
  position: relative;
  cursor: pointer;
  transition: 0.5s;
  margin-top: 5px;
  max-width: 80%;
  word-wrap: break-word;
}

.timeline ul li span {
  color: #094a68;
  word-wrap: break-word;
}

.timeline ul li:before {
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  background-color: #34ace0;
  border-radius: 50%;
  left: -11px;
  top: 28px;
  transition: 0.5s;
}

.timeline ul li:hover:before {
  background-color: rgb(255, 208, 0);
  box-shadow: 0px 0px 10px 2px rgb(255, 208, 0);
}

.timeline ul .clicked:before {
  background-color: #0f0;
  box-shadow: 0px 0px 10px 2px #0f0;
}

.timeline ul .unclicked:before {
  background-color: #34ace0;
  box-shadow: none;
}

@media (max-width: 300px) {
  .timeline {
    width: 100%;
    padding: 30px 5px 30px 10px;
  }

  .timeline ul li .content h3 {
    color: #34ace0;
    font-size: 15px;
  }
}

.section-visit {
  background: #ebebeb;
  margin-bottom: 1rem;
  padding: 1rem;
}

.section-consultant {
  margin: 1.5rem 0.5rem;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0px 6px 24px #e4e4e4;
}

.modify-consulting-paper {
  padding: 1rem;
  max-height: 100%;
  max-width: 100%;
}

.visit-row {
  margin-top: 2rem;
}

.section-visit-sec {
  margin: 1.75rem 0.5rem;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0px 6px 24px #e4e4e4;
}

.section-visit-summery {
  margin: 0.5rem;
  padding: 1rem;
  color: black;
  border-radius: 8px;
  box-shadow: 0px 6px 24px #e4e4e4;
}

.summery {
  background-color: rgba(237, 238, 245, 0.431);
  padding: 1.5rem;
  margin: 1rem;
  border-radius: 5px;
}

.total_score {
  background-color: rgb(237, 238, 245);
  padding: 0.5rem 1rem;
  border-radius: 15px;
  box-shadow: 0px 6px 10px #ebebeb;
}

table,
td,
th {
  border: 1px solid;
}

.sign-table,
.sign-table > tr > td {
  border: none !important;
}

table {
  width: 100%;
  background: white;
  border-collapse: collapse;
}

table > tr > td {
  width: 6rem;
  text-align: center;
}

.patient-table > tr > td {
  padding-left: 0.5rem;
  border: 1px solid;
  text-align: left;
}
</style>
